import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikValues, useFormik } from 'formik';
import * as Yup from 'yup';
import InputPassword from '../../Common/Input/InputPassword';
import ButtonPrimary from '../../Common/Button/Primary/ButtonPrimary';

interface PasswordConfirmFormProps {
  submitButtonLabel: string;
  onSubmit: (values: FormikValues) => void;
}
function PasswordConfirmForm(props: PasswordConfirmFormProps) {
  const { submitButtonLabel, onSubmit } = props;
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required(t('common.form.validation.password.required'))
        .min(6, t('common.form.validation.password.short'))
        .max(256, t('common.form.validation.password.long'))
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$/, t('common.form.validation.password.letters')),
      confirmPassword: Yup.string()
        .required(t('common.form.validation.password.required'))
        .oneOf([Yup.ref('password'), null], t('common.form.validation.password.confirm')),
    }),
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputPassword
        id={'password'}
        name={'password'}
        type={'password'}
        label={t('common.form.label.password.new')}
        placeholder={t('common.form.placeholder.password')}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
        touched={formik.touched.password}
        error={formik.errors.password}
      />
      <InputPassword
        id={'confirmPassword'}
        name={'confirmPassword'}
        type={'password'}
        label={t('common.form.label.password.confirm')}
        placeholder={t('common.form.placeholder.password')}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.confirmPassword}
        touched={formik.touched.confirmPassword}
        error={formik.errors.confirmPassword}
      />
      <ButtonPrimary type={'submit'} disabled={!(formik.isValid && formik.dirty)} label={submitButtonLabel} />
    </form>
  );
}

export default PasswordConfirmForm;
